module.exports = __webpack_public_path__ + "img/default-head.de2401bf.jpg";